import { Navigate, Outlet } from 'react-router-dom';
import { useMdr, type MdrTier } from '../../hooks/useMdr';

/**
 * Gate nested MDR routes by mdrTier. A non-matching MDR user is bounced to the
 * MDR dashboard (backend route guards enforce this regardless).
 */
export function RequireMdrTier({ allow }: { allow: Exclude<MdrTier, null>[] }) {
  const { tier } = useMdr();
  if (!tier || !allow.includes(tier)) {
    return <Navigate to="/mdr/dashboard" replace />;
  }
  return <Outlet />;
}
